<template>
  <div class="d-flex align-center justify-space-between mb-3">
    <div class="d-flex flex-column">
      <div class="d-flex align-center ga-1">
        <span class="font-weight-bold d-block font-size-15"> Підрозділи </span>
        <span class="text-disabled font-size-13">
          ({{ journalSource.departments?.length }})
        </span>
      </div>
      <span class="text-disabled">
        Підрозділи, які можуть використовувати даний журнал
      </span>
    </div>
    <entity-select-menu
      :selected-items="journalSource.departments"
      directory-key="activeInternalDepartments"
      @select-item="addDepartment"></entity-select-menu>
  </div>
  <div v-if="journalSource.departments?.length" class="d-flex flex-column ga-2">
    <v-card
      v-for="department in journalSource.departments"
      :key="department.id"
      border>
      <v-card-text>
        <div class="d-flex align-center justify-space-between">
          <div class="d-flex align-center ga-2">
            <div class="icon--blue">
              <v-icon icon="mdi-briefcase-outline" size="23"></v-icon>
            </div>
            <span class="font-size-14">{{ department.name }}</span>
          </div>
          <v-btn
            :loading="
              $loading.isLoading(
                `registrationJournalDepartmentDelete_${department.id}`
              )
            "
            border
            class="text-none"
            size="small"
            style="border-color: #ddd"
            variant="outlined"
            @click="deleteDepartment(department.id)">
            <span class="font-weight-medium text-error"> Видалити </span>
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
  <v-card v-else border color="grey-lighten-5">
    <v-card-text class="d-flex justify-center align-center py-8">
      <span class="text-disabled d-block"> Немає прив'язаних підрозділів </span>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import EntitySelectMenu from '@/components/inputs/EntitySelectMenu.vue'
import { useRegistrationJournal } from '../registrationJournal'
import { confirm, handleAsync, setSnackbar } from 'best-modules/plugins'
import {
  registrationJournalDepartmentCreate,
  registrationJournalDepartmentDelete,
} from '@/requests/registrationJournal'
import { RegistrationJournalDepartment } from '@/utils/types/registrationJournal'

export default {
  name: 'RegistrationJournalDepartments',
  components: { EntitySelectMenu },
  setup() {
    const { journalSource, journalId } = useRegistrationJournal()

    const addDepartment = (item: RegistrationJournalDepartment) => {
      return registrationJournalDepartmentCreate(journalId.value, item.id).then(
        res => {
          journalSource.departments = res.departments
          setSnackbar({ text: 'Підрозділ додано до журналу' })
        }
      )
    }

    const deleteDepartment = (departmentId: number) => {
      confirm({
        text: 'Ви дійсно бажаєте видалити підрозділ з журналу реєстрацій?',
      }).then(() => {
        return handleAsync(
          `registrationJournalDepartmentDelete_${departmentId}`,
          () => {
            return registrationJournalDepartmentDelete(
              journalId.value,
              departmentId
            ).then(res => {
              if (res) {
                journalSource.departments = res.departments
                setSnackbar({ text: 'Підрозділ видалено з журналу' })
              }
            })
          }
        )
      })
    }

    return {
      addDepartment,
      deleteDepartment,
      journalSource,
    }
  },
}
</script>

<style lang="scss" scoped></style>
